import { createSlice } from '@reduxjs/toolkit';

/**
 * @typedef {Object} FeatureObject
 * @property {string} feature - The feature name/identifier
 * @property {string} status - The status of the feature (e.g., "releasedByDistr", "isRelease", "test", etc.), if not exist means feature is not allowed
 */

/**
 * @typedef {Object.<string, FeatureObject>} AllowedFeaturesObject
 * @example
 * // Example structure:
 * {
 *   smile_design: {
 *     feature: "smile_design",
 *     status: "releasedByDistr"
 *   },
 *   order_retainer: {
 *     feature: "order_retainer",
 *     status: "isRelease"
 *   }
 * }
 */

export const AllowedFeaturesObject = {};

/**
 * @typedef {Object} UserAllowedFeaturesState
 * @property {AllowedFeaturesObject|null} allowedFeatures - Object containing user's allowed features with their statuses, or null if not loaded
 */

/**
 * Initial state for user allowed features
 * @type {UserAllowedFeaturesState}
 */

export const UserAllowedFeaturesState = {};
const initialState = {
    allowedFeatures: null,
};
const userAllowedFeaturesSlice = createSlice({
    name: 'userAllowedFeatures',
    initialState,
    reducers: {
        setUserAllowedFeatures: (state, action) => {
            return {
                ...state,
                allowedFeatures: action.payload,
            };
        },
        clearUserAllowedFeatures: (state) => {
            return {
                ...initialState,
            };
        },
    },
});

export const { setUserAllowedFeatures, clearUserAllowedFeatures } = userAllowedFeaturesSlice.actions;

export const userAllowedFeaturesReducer = userAllowedFeaturesSlice.reducer;
